var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmartPlug(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg_sidebar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3226",
    "data-name": "Group 3226",
    transform: "translate(-752 -2276)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1882",
    "data-name": "Rectangle 1882",
    width: 24,
    height: 24,
    transform: "translate(752 2276)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_139_853676",
    transform: "translate(757 2279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4389",
    "data-name": "Path 4389",
    d: "M30.3,1.6V5.269h4.2Z",
    transform: "translate(-20.854 -1.18)",
    fill: "#e8eafd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4390",
    "data-name": "Path 4390",
    d: "M14.279,6.117a.767.767,0,0,1-.765-.764V.5H6.365a.767.767,0,0,0-.765.764V17.736a.767.767,0,0,0,.765.764H18.9a.767.767,0,0,0,.765-.764V6.117ZM7.818,7.876c0-.42.23-.764.573-.764h4.932c.306,0,.573.344.573.764s-.23.764-.573.764H8.352a.7.7,0,0,1-.535-.766Zm8.908,3.363-4.779,4.738a.74.74,0,0,1-1.07,0L8.888,13.99a.757.757,0,0,1,1.07-1.07l1.453,1.452,4.244-4.241a.74.74,0,0,1,1.07,0,.784.784,0,0,1,0,1.107Z",
    transform: "translate(-5.6 -0.5)",
    fill: "#e8eafd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartPlug);
export default __webpack_public_path__ + "static/media/smart-plug.b2f5188ce7cc38b93e8df8b77e69ac63.svg";
export { ForwardRef as ReactComponent };